"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = exports.Component = exports.App = void 0;
const app_1 = __importDefault(require("./app"));
exports.App = app_1.default;
const component_1 = __importDefault(require("./component"));
exports.Component = component_1.default;
const loader_1 = __importDefault(require("./loader"));
exports.Loader = loader_1.default;
//# sourceMappingURL=index.js.map